(function () {
  'use strict';

  var R36S_ID = 9374899175643;
  var CARRY_CASE_ID = 9374900453595;
  var CARRY_CASE_VARIANT = 48879899148507;
  var EARBUDS_ID = 9375002919131;
  var EARBUDS_VARIANT = 48880494969051;
  var FREE_SHIPPING_CENTS = 10000;

  function getCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).catch(function () { return null; });
  }

  function addVariant(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (r) { return r.json(); });
  }

  function renderShippingBar(cart) {
    var total = cart.total_price;
    var el = document.createElement('div');
    el.className = 'retro-shipping-bar';
    if (total >= FREE_SHIPPING_CENTS) {
      el.innerHTML = '<p class="retro-shipping-bar__msg retro-shipping-bar__msg--done">Free shipping unlocked!</p>';
    } else {
      var remaining = ((FREE_SHIPPING_CENTS - total) / 100).toFixed(2);
      var pct = Math.round((total / FREE_SHIPPING_CENTS) * 100);
      el.innerHTML = '<p class="retro-shipping-bar__msg">Add <strong>$' + remaining + '</strong> more for free shipping</p><div class="retro-shipping-bar__track"><div class="retro-shipping-bar__fill" style="width:' + pct + '%"></div></div>';
    }
    return el;
  }

  function renderUpsell(cart) {
    var ids = cart.items.map(function (i) { return i.product_id; });
    if (!ids.includes(R36S_ID)) return null;
    var rows = [];
    if (!ids.includes(CARRY_CASE_ID)) {
      rows.push('<div class="retro-upsell-row"><div class="retro-upsell-row__info"><span class="retro-upsell-row__name">Carry Case</span><span class="retro-upsell-row__price">$24.99</span></div><button class="retro-upsell-row__btn" data-variant="' + CARRY_CASE_VARIANT + '">+ Add</button></div>');
    }
    if (!ids.includes(EARBUDS_ID)) {
      rows.push('<div class="retro-upsell-row"><div class="retro-upsell-row__info"><span class="retro-upsell-row__name">Gaming Earbuds</span><span class="retro-upsell-row__price">$34.99</span></div><button class="retro-upsell-row__btn" data-variant="' + EARBUDS_VARIANT + '">+ Add</button></div>');
    }
    if (!rows.length) return null;
    var el = document.createElement('div');
    el.className = 'retro-cart-upsell';
    el.innerHTML = '<p class="retro-cart-upsell__title">Complete your setup</p><div class="retro-cart-upsell__items">' + rows.join('') + '</div>';
    return el;
  }

  function wireUpsellButtons(upsell) {
    if (!upsell) return;
    upsell.querySelectorAll('.retro-upsell-row__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.textContent = 'Adding...';
        btn.disabled = true;
        addVariant(Number(btn.dataset.variant)).then(function () {
          setTimeout(refreshCartUI, 400);
        }).catch(function () {
          btn.textContent = 'Error';
        });
      });
    });
  }

  function refreshCartUI() {
    getCart().then(function (cart) {
      if (!cart || !cart.item_count) return;
      var content = document.querySelector('.cart-drawer__content');
      if (!content) return;
      content.querySelectorAll('.retro-shipping-bar, .retro-cart-upsell').forEach(function (el) { el.remove(); });
      var itemsEl = content.querySelector('.cart-drawer__items');
      var summaryEl = content.querySelector('.cart-drawer__summary');
      var bar = renderShippingBar(cart);
      var upsell = renderUpsell(cart);
      if (itemsEl) itemsEl.insertAdjacentElement('beforebegin', bar);
      if (summaryEl && upsell) { summaryEl.insertAdjacentElement('beforebegin', upsell); wireUpsellButtons(upsell); }
    });
  }

  function injectTrustBadges() {
    if (document.querySelector('.retro-trust-badges')) return;
    var btn = document.querySelector('.product-form__submit, product-form button[type="submit"], [name="add"]');
    if (!btn) return;
    var anchor = btn.closest('form, product-form') || btn.parentElement;
    if (!anchor) return;
    var badges = document.createElement('div');
    badges.className = 'retro-trust-badges';
    badges.innerHTML = '<div class="retro-trust-badge"><span class="rtb-icon">AU</span>Australian Warehouse</div><div class="retro-trust-badge"><span class="rtb-icon">30D</span>Free Returns</div><div class="retro-trust-badge"><span class="rtb-icon">$100</span>Free Shipping</div><div class="retro-trust-badge"><span class="rtb-icon">SSL</span>Secure Checkout</div>';
    anchor.insertAdjacentElement('afterend', badges);
  }

  var cartObserver = null;
  function watchCart() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer || cartObserver) return;
    cartObserver = new MutationObserver(function () {
      if (document.querySelector('.cart-drawer__content')) setTimeout(refreshCartUI, 80);
    });
    cartObserver.observe(drawer, { childList: true, subtree: true });
  }

  function init() {
    injectTrustBadges();
    watchCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('page:loaded', function () {
    injectTrustBadges();
  });
})();
